import React, { useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import Highcharts from "highcharts/highstock";
import { IconContext } from "react-icons"
import { FcAreaChart } from 'react-icons/fc';
import HighchartsReact from "highcharts-react-official";
import { connect } from "react-redux"
import { getSaleHistory } from "../../../../actions/productAction"
import FontAwesome from "react-fontawesome";
import Chart from "./Chart"

function Graph({ shoesData, saleHistory, getSaleHistory, setNoGraphData }) {
  const { data } = saleHistory
  const { id } = shoesData;
  const [noData, setNoData] = useState(false)

  const [graphData, setGraphData] = useState({
    series: [],
    interval: 0,
    maxPrice: 0
  })

  useEffect(() => {
    id && getSaleHistory(id, "brandnew", "all");
  }, [id]);

  useEffect(() => {
    const setData = ({ data }) => {
      const salesData = data?.[id]?.[0];
      const salesHistoryDataForSeries = salesData?.points
      const maxYaxes = salesData?.highest_price + Math.round(salesData?.highest_price / 10)
      const minYaxes = salesData?.lowest_price

      if (!salesData || !salesData?.points) {
        setNoData(true)
        setNoGraphData(true)
        setGraphData({ ...graphData, series: [], interval: 0, maxPrice: maxYaxes })
        return
      }

      if (Array.isArray(salesData) && salesData.length === 0) {
        setNoData(true)
        setNoGraphData(true)
        setGraphData({ ...graphData, series: [], interval: 0, maxPrice: maxYaxes })
        return
      }

      const interval = salesHistoryDataForSeries && (salesHistoryDataForSeries[1][0] - salesHistoryDataForSeries[0][0]) * 3

      setNoData(false)
      setNoGraphData(false)
      setGraphData({ ...graphData, series: salesHistoryDataForSeries, interval, maxPrice: maxYaxes })
    }
    id && setData(data)
  }, [data])

  const [activeBtn, setActiveBtn] = useState({
    "1M": "",
    "3M": "",
    "6M": "",
    "1Y": "",
    "YTD": "",
    "All": "chart-filter-btn-active",
  })

  const activeBtnHandler = (filter) => {
    switch (filter) {
      case "1M":
        setActiveBtn({
          ...activeBtn,
          ["1M"]: "chart-filter-btn-active",
          ["3M"]: "",
          ["6M"]: "",
          ["1Y"]: "",
          ["YTD"]: "",
          ["All"]: ""
        })

        getSaleHistory(id, "brandnew", "1m")
        break;
      case "3M":
        setActiveBtn({
          ...activeBtn,
          ["1M"]: "",
          ["3M"]: "chart-filter-btn-active",
          ["6M"]: "",
          ["1Y"]: "",
          ["YTD"]: "",
          ["All"]: ""
        })

        getSaleHistory(id, "brandnew", "3m")
        break;
      case "6M":
        setActiveBtn({
          ...activeBtn,
          ["1M"]: "",
          ["3M"]: "",
          ["6M"]: "chart-filter-btn-active",
          ["1Y"]: "",
          ["YTD"]: "",
          ["All"]: ""
        })

        getSaleHistory(id, "brandnew", "6m")
        break;
      case "1Y":
        setActiveBtn({
          ...activeBtn,
          ["1M"]: "",
          ["3M"]: "",
          ["6M"]: "",
          ["1Y"]: "chart-filter-btn-active",
          ["YTD"]: "",
          ["All"]: ""
        })

        getSaleHistory(id, "brandnew", "1y")
        break;
      case "YTD":
        setActiveBtn({
          ...activeBtn,
          ["1M"]: "",
          ["3M"]: "",
          ["6M"]: "",
          ["1Y"]: "",
          ["YTD"]: "chart-filter-btn-active",
          ["All"]: ""
        })

        getSaleHistory(id, "brandnew", "ytd")
        break;
      default:
        setActiveBtn({
          ...activeBtn,
          ["1M"]: "",
          ["3M"]: "",
          ["6M"]: "",
          ["1Y"]: "",
          ["YTD"]: "",
          ["All"]: "chart-filter-btn-active"
        })
        getSaleHistory(id, "brandnew", "all")
        break;
    }
  }

  if (noData) return <div />;

  return (
    <div className="chart-container">
      <div>
        <div className="chart-title">
          <span>Product Historical Data</span>
        </div>
        <div className={"chart-filter-btn-wrapper"}>
          <button onClick={() => activeBtnHandler("1M")} className={`chart-filter-btn ${activeBtn["1M"]}`}>1M</button>
          <button onClick={() => activeBtnHandler("3M")} className={`chart-filter-btn ${activeBtn["3M"]}`}>3M</button>
          <button onClick={() => activeBtnHandler("6M")} className={`chart-filter-btn ${activeBtn["6M"]}`}>6M</button>
          <button onClick={() => activeBtnHandler("1Y")} className={`chart-filter-btn ${activeBtn["1Y"]}`}>1Y</button>
          <button onClick={() => activeBtnHandler("YTD")} className={`chart-filter-btn ${activeBtn["YTD"]}`}>YTD</button>
          <button onClick={() => activeBtnHandler("All")} className={`chart-filter-btn ${activeBtn["All"]}`}>All</button>
        </div>
        <div className="chart-title-text">
        </div>
        <div className="chart-not-error-wrapper">
          <Chart series={graphData.series} interval={graphData.interval} maxPrice={graphData.maxPrice} />
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  saleHistory: state.dataProduct.saleHistory,
});
const mapDispatchToProps = {
  getSaleHistory
}
export default connect(mapStateToProps, mapDispatchToProps)(Graph)